// extracted by mini-css-extract-plugin
export default {"trigger":"search-trigger_trigger__eCRl4","text":"search-trigger_text__mK3tq","shortcut":"search-trigger_shortcut__9tCGu"};